<template>
  <b-tabs id="account-page-tabs" class="mb-5" lazy>
    <b-tab>
      <template #title>
        <feather-icon icon="ShieldIcon" />
        <div class="font-small-1 tab-title">
          {{ $t("Security") }}
        </div>
      </template>
      <b-row>
        <b-col cols="12">
          <password-card />
        </b-col>
      </b-row>
    </b-tab>
  </b-tabs>
</template>

<script>
import { BRow, BCol, BTab, BTabs } from "bootstrap-vue";
import { notifyError } from "@methods";
import PasswordCard from "@/views/account/components/PasswordCard.vue";

export default {
  components: {
    BRow,
    BCol,
    BTab,
    BTabs,
    PasswordCard,
  },
  computed: {
    userData() {
      return JSON.parse(localStorage.getItem("foravilaProvidersUserData"));
    },
    providerUuid() {
      return this.userData.provider.uuid;
    },
    loading() {
      return this.$store.getters["provider/loading"];
    },
    provider() {
      return this.$store.getters["provider/provider"];
    },
  },
  created() {
    if (!this.provider) this.fetchProvider();
  },
  methods: {
    fetchProvider() {
      this.$store
        .dispatch("providers/fetchProvider", this.providerUuid)
        .catch(() =>
          notifyError(
            this.$t("errors.fetchProvider.title"),
            this.$t("errors.fetchProvider.text")
          )
        );
    },
  },
};
</script>

<style lang="scss">
#account-page-tabs {
  .nav {
    padding-bottom: 10px;
    display: flex;
    overflow: hidden;
    overflow-x: scroll;
    flex-wrap: nowrap;
    list-style: none;
    white-space: nowrap;
  }

  // Medium devices (tablets, 768px and up)
  @media (min-width: 768px) {
    .nav-tabs::-webkit-scrollbar {
      display: none; // Safari and Chrome
    }
  }

  .nav-link {
    display: block !important;
    text-align: center;
    align-items: center;
    justify-content: center;
  }

  .nav-link::after {
    background: none !important;
  }

  // Medium devices (tablets, 768px and up)
  @media (min-width: 768px) {
    .nav-link::after {
      background: linear-gradient(30deg,
          #ffcd00,
          rgba(255, 205, 0, 0.5)) !important;
    }
  }

  // Large devices (desktops, 992px and u
  @media (min-width: 992px) {
    .tab-title {
      font-size: 1rem !important;
    }
  }
}
</style>
